module.exports = __webpack_public_path__ + "img/4064010610.c000b0da.jpg";